import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Page from 'components/Page';
import ScrollAnimation from 'components/ScrollAnimation';
import BannerImage from 'components/BannerImage';
import ContentBlock from 'components/ContentBlock';
import ContentBlockFull from 'components/ContentBlockFull';
import ColumnTwo from 'components/ColumnTwo';
import Container from 'components/Container';
import Slider from 'components/Slider';
import Spacing from 'components/Spacing';
import Map from './elements/Map/Map';

const gallery = [
  [
    {
      image: require('src/assets/images/neighbourhood/gallery-1/ubc1.jpg'),
      caption: 'Wesbrook Community Centre',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-1/ubc2.jpg'),
      caption: 'Wesbrook Park',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-1/ubc3.jpg'),
      caption: 'Wesbrook Community Centre',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-1/vegetables.jpg'),
      caption: 'UBC Farmers Market',
    },
  ],
  [
    {
      image: require('src/assets/images/neighbourhood/gallery-2/img1.jpg'),
      caption: 'Morris and Helen Belkin Art Gallery',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-2/img2.jpg'),
      caption: 'Nitobe Memorial Garden at  UBC',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-2/img3.jpg'),
      caption: 'The Chan Centre for Performing Arts at UBC',
    },
    {
      image: require('src/assets/images/neighbourhood/gallery-2/img4.jpg'),
      caption: 'Inushuk - Museum of Anthropology',
    },
  ],
];

class Neighbourhood extends Component {
  render() {
    return (
      <Page
        background={require('src/assets/images/neighbourhood/banner.jpg')}
        banner={<BannerImage />}
      >
        <ScrollAnimation>
          <ContentBlockFull
            center={true}
            title={<span>{t('neighbourhood.title')}</span>}
            subtitle={t('neighbourhood.subtitle')}
          >
            <Container>
              <p>{t('neighbourhood.copy')}</p>
            </Container>
          </ContentBlockFull>
        </ScrollAnimation>

        <ScrollAnimation>
          <Row>
            <Column slider>
              <Slider slides={gallery[0]} />
            </Column>
            <Column>
              <Content>
                <ContentBlock
                  center={true}
                  title={t('neighbourhood.sections.0.title')}
                  subtitle={t('neighbourhood.sections.0.subtitle')}
                >
                  <Spacing value="150px" md="80px" />
                  <p>{t('neighbourhood.sections.0.copy')}</p>
                </ContentBlock>
              </Content>
            </Column>
          </Row>
        </ScrollAnimation>
        <ScrollAnimation>
          <Row>
            <Column>
              <Content left>
                <ContentBlock
                  center={true}
                  title={t('neighbourhood.sections.1.title')}
                  subtitle={t('neighbourhood.sections.1.subtitle')}
                >
                  <Spacing value="150px" md="80px" />
                  <p>{t('neighbourhood.sections.1.copy')}</p>
                </ContentBlock>
              </Content>
            </Column>
            <Column slider>
              <Slider slides={gallery[1]} />
            </Column>
          </Row>
        </ScrollAnimation>

        <ScrollAnimation>
          <Map />
        </ScrollAnimation>

        <ScrollAnimation>
          <ColumnTwo
            left={
              <Collage
                src={require('src/assets/images/neighbourhood/collage.jpg')}
              />
            }
            right={
              <ContentBlock
                center={true}
                title={t('neighbourhood.sections.2.title')}
              >
                <p>{t('neighbourhood.sections.2.copy')}</p>
                <Collage
                  src={require('src/assets/images/neighbourhood/collage.jpg')}
                  mobile
                />
              </ContentBlock>
            }
          />
        </ScrollAnimation>
      </Page>
    );
  }
}

const Row = styled.div`
  display: flex;
  @media (max-width: ${media.md}) {
    flex-wrap: wrap;
  }
`;

const Column = styled.div`
  width: 50%;
  padding: ${props => (props.slider ? '0' : '60px')};
  @media (max-width: ${media.md}) {
    width: 100%;
    order: ${props => (props.slider ? '1' : '2')};
    padding: ${props => (props.slider ? '0' : '10px')};
  }
`;

const Content = styled.div`
  max-width: 660px;
  width: 100%;
  padding: 20px;
  float: ${props => (props.left ? 'right' : 'none')};
  @media (max-width: ${media.md}) {
    float: none !important;
  }
`;

const Collage = styled.img`
  max-width: 100%;
  display: ${props => (props.mobile ? 'none' : 'block')};
  @media (max-width: ${media.md}) {
    display: ${props => (props.mobile ? 'block' : 'none')};
    margin: 0 auto;
    padding: 20px 0 60px;
  }
`;

export default Neighbourhood;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood/Neighbourhood.js